import type { Locale } from "./locales";

const LOCALE_KEY = "locale";

/**
 * The selected locale, persisted across sessions. Shared because the customer
 * portal writes it (profile settings) and oem's LanguageProvider reads it.
 */
export const getLocaleFromStorage = (): Locale | null => {
  try {
    const raw = localStorage.getItem(LOCALE_KEY);
    return raw ? (JSON.parse(raw) as Locale) : null;
  } catch {
    return null;
  }
};

export const saveLocaleToStorage = (data: Locale) => {
  if (data) {
    localStorage.setItem(LOCALE_KEY, JSON.stringify(data));
  }
};
